import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { getFirstContentElement } from "utils/getFirstContentElement";
import { scrollToSection } from "utils/scrollTo";
import { useSitecoreContext } from "stores/sitecoreContext";

const SkipUrl = styled.button.attrs(({ role }) => ({
  role: role,
}))`

  background-color: #767676 !important;
  @media print {
    display: none;
  }

  &:focus {
    z-index: 99;
    top: 7rem;
  }
`;

if (typeof window !== "undefined" && !window.__skipComponentMounted) {
  window.__skipComponentMounted = false;
}

const SkipToComponent = () => {
  let skipToRef = useRef(null);
  
  const [shouldRender, setShouldRender] = useState(false);
  const { itemPath = "" } = useSitecoreContext() || {};
  const currentPath =
    typeof window !== "undefined" &&
    window.location &&
    window.location.pathname;

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (!window.__skipComponentMounted) {
        window.__skipComponentMounted = true;
        setShouldRender(true);
        
        return () => {
          window.__skipComponentMounted = false;
        };
      }
    }
  }, []);
  
  useEffect(() => {
     //skipToRef.current.focus();
    //document.activeElement.blur();
    //console.log(document.activeElement)
    //console.log(itemPath, currentPath);
    if (
      itemPath !== "/404" &&
      itemPath.toLowerCase() !== currentPath.toLowerCase() &&
      typeof window !== "undefined"
    )
      window.location.reload();
  }, [itemPath, currentPath]);

  const onKeyUp = function (event) {
    if (
      event.key === "Tab" &&
      (!document.activeElement || document.activeElement.tagName === "BODY")
    ) {
      skipToRef.current && skipToRef.current.focus();
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined" && shouldRender) {
      window.addEventListener("keyup", onKeyUp);

      return function () {
        window.removeEventListener("keyup", onKeyUp);
      };
    }
  }, [shouldRender]);

  const onSkipToMainContentClick = () => {
    let firstElement = getFirstContentElement();
    if (firstElement) firstElement.focus();
    else {
      const root = document.querySelector("#root");
      const sections = root.querySelectorAll("section");

      for (let i = 0; i < sections.length; i++) {
        const activeElements = sections[i].querySelectorAll(
          "button, [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])"
        );
        if (activeElements.length > 0) {
          activeElements[0].focus();
          break;
        }
      }
    }
  };

  const onSkipToFooter = () => {
    let footer = document.getElementById("footer");
    if (footer) scrollToSection("footer");
  };

  if (!shouldRender) return null;

  return (
    <>
      <SkipUrl
        id="skip-to-main"
        className="w-auto block absolute font-graphie z-0 top-0 text-white no-underline p-3 tracking-wide
       focus:left-0 focus:border-solid focus:border-gray-800 focus:bg-opacity-75 hover:cursor-default"
        onClick={(e) => {
          e.preventDefault();
          onSkipToMainContentClick();
        }}
        ref={skipToRef}
        role="link"
        onFocus={(e) => {
          const root = document.querySelector("#root");
          const modals = root.querySelectorAll('[role="dialog"]');
          if (modals.length > 0) {
            const activeElements = modals[0].querySelectorAll(
              "button, [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])"
            );
            if (activeElements.length > 0) {
              activeElements[0].focus();
              e.preventDefault();
            }
          }
        }}
      >
        Skip to main content
      </SkipUrl>
      <SkipUrl
        className="w-auto block absolute font-graphie z-0 top-0 bg-gray-600 text-white no-underline p-3 tracking-wide
    focus:left-0 focus:border-solid focus:border-gray-800 focus:bg-opacity-75 hover:cursor-default"
        onClick={onSkipToFooter}
        role="link"
      >
        Skip to footer
      </SkipUrl>
    </>
  );
};

export default SkipToComponent;